import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import { withRouter } from '../withRouter';
import styles from "components/AppView/AppNavStyles.module.scss";
import logo from '../../images/logo.png';

class AppNavMenu extends Component {
    static displayName = AppNavMenu.name;

    constructor(props) {
        super(props);

        this.state = {
            showMenu: false,
            showUserMenu: false,
        };
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    render() {
        return (
            <header className={`${styles.header}`}>
                <Container fluid className={styles.headerInner}>
                    <div className={`${styles.logo}`}>
                        <img src={logo} alt="" width="153" height="80"></img>
                    </div>
                </Container>
            </header>
        );
    }
}



export default withRouter(AppNavMenu);
